
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2062","transform":"translate(-1577 -6037)"}},[_c('circle',{attrs:{"data-name":"Ellipse 297","cx":"22","cy":"22","r":"22","transform":"translate(1577 6037)","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 2781","d":"M1613.486 6052.884a7.124 7.124 0 00-1.114-3 3.722 3.722 0 00-2.812-1.26c-3.926-.3-9.841-.339-9.841-.339s-5.914.049-9.841.339a3.917 3.917 0 00-2.812 1.26 6.476 6.476 0 00-1.11 3 48.5 48.5 0 00-.3 4.944v2.279a46.933 46.933 0 00.3 4.9 7.134 7.134 0 001.114 3 4.658 4.658 0 003.102 1.312c2.23.242 9.55.3 9.55.3s5.914 0 9.841-.339a3.917 3.917 0 002.812-1.26 7.123 7.123 0 001.114-3 48.039 48.039 0 00.3-4.9v-2.291a48.5 48.5 0 00-.3-4.944"}}),_c('path',{attrs:{"data-name":"Path 2782","d":"M1596.325 6054.048v10.52l9.211-5.139z","fill":"#fff"}})])])
          )
        }
      }
    